export function isBrowseriniOS(): boolean {
  const { userAgent } = window.navigator;
  return Boolean(userAgent.match(/iPad/i) || userAgent.match(/iPhone/i));
}
